import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule } from '@angular/forms';

import { ButtonModule } from '../button/button.module';
import { SelectBoxComponent } from './select-box.component';
import { SelectBoxItemComponent } from './select-box-item.component';

import { SelectBoxDefaultOptions } from './models/select-box-default-options';
import { OffClickDirective } from './directives/off-click.directive';
import { ItemPipe } from './item.pipe';

import { NzGridModule } from 'ng-zorro-antd'
export const COMPONENTS = [SelectBoxComponent, SelectBoxItemComponent];

@NgModule({
  declarations: [...COMPONENTS, ItemPipe, OffClickDirective],
  imports: [CommonModule, FormsModule, NzGridModule, ButtonModule],
  exports: [...COMPONENTS],
  entryComponents: [...COMPONENTS],
  providers: [SelectBoxDefaultOptions],
})
export class SelectBoxModule {
  public static forRoot(options: SelectBoxDefaultOptions): ModuleWithProviders {
    return {
      ngModule: SelectBoxModule,
      providers: [
        { provide: SelectBoxDefaultOptions, useValue: options }
      ]
    };
  }
}

